import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';

import { IntegrationsService } from '@services/integrations.service';
import { SnackBarService } from '@services/snack-bar.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-zoom-redirect',
  templateUrl: './zoom-redirect.component.html',
  styleUrls: ['./zoom-redirect.component.scss'],
  imports: [CommonModule, TranslateModule, MatIconModule],
})
export class ZoomRedirectComponent implements OnInit {
  isProcessing = true;
  error = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private integrationsService: IntegrationsService,
    private snackbarService: SnackBarService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      const code = params['code'];
      const error = params['error'];

      if (error) {
        this.error = true;
        this.isProcessing = false;
        this.snackbarService.error(
          this.translateService.instant(
            'settings.integrations.zoom.snackbar.zoomError',
          ),
        );
        return;
      }

      if (!code) {
        this.error = true;
        this.isProcessing = false;
        this.snackbarService.error(
          this.translateService.instant(
            'settings.integrations.zoom.invalidZoomResponse',
          ),
        );
        return;
      }

      this.integrationsService
        .exchangeZoomAuthCode(code)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this.isProcessing = false;
            this.snackbarService.success(
              this.translateService.instant(
                'settings.integrations.zoom.snackbar.successfulMessage',
              ),
            );
            this.router.navigate(['/settings/integrations']);
          },
          error: () => {
            this.error = true;
            this.isProcessing = false;
            this.snackbarService.error(
              this.translateService.instant(
                'settings.integrations.zoom.snackbar.failedMessage',
              ),
            );
            this.router.navigate(['/settings/integrations']);
          },
        });
    });
  }
}
